import { render, staticRenderFns } from "./inquire.vue?vue&type=template&id=4c10184f&scoped=true&"
import script from "./inquire.vue?vue&type=script&lang=js&"
export * from "./inquire.vue?vue&type=script&lang=js&"
import style0 from "./inquire.vue?vue&type=style&index=0&id=4c10184f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c10184f",
  null
  
)

export default component.exports